// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lds-ring {
  display: inline-block;
  position: relative;
  width: var(--width);
  height: var(--height);
}

.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: var(--width);
  height: var(--height);
  margin: 6px;
  border: var(--border) solid var(--color);
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: var(--color) transparent transparent transparent;
}

.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}

.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}

.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}

@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./projects/zbs-app/src/app/modules/shared/spinner/spinner.component.scss"],"names":[],"mappings":"AAMA;EACI,qBAAA;EACA,kBAAA;EACA,mBATI;EAUJ,qBATK;AAIT;;AAOE;EACE,sBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAhBI;EAiBJ,qBAhBK;EAiBL,WAAA;EACA,wCAAA;EACA,kBAAA;EACA,8DAAA;EACA,8DAAA;AAJJ;;AAME;EACE,uBAAA;AAHJ;;AAKE;EACE,sBAAA;AAFJ;;AAIE;EACE,uBAAA;AADJ;;AAGE;EACE;IACE,uBAAA;EAAJ;EAEE;IACE,yBAAA;EAAJ;AACF","sourcesContent":["$width: var(--width);\r\n$height: var(--height);\r\n$border: var(--border);\r\n\r\n$color: var(--color);\r\n\r\n.lds-ring {\r\n    display: inline-block;\r\n    position: relative;\r\n    width: $width;\r\n    height: $height;\r\n  }\r\n  .lds-ring div {\r\n    box-sizing: border-box;\r\n    display: block;\r\n    position: absolute;\r\n    width: $width;\r\n    height: $height;\r\n    margin: 6px;\r\n    border: $border solid $color;\r\n    border-radius: 50%;\r\n    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;\r\n    border-color: $color transparent transparent transparent;\r\n  }\r\n  .lds-ring div:nth-child(1) {\r\n    animation-delay: -0.45s;\r\n  }\r\n  .lds-ring div:nth-child(2) {\r\n    animation-delay: -0.3s;\r\n  }\r\n  .lds-ring div:nth-child(3) {\r\n    animation-delay: -0.15s;\r\n  }\r\n  @keyframes lds-ring {\r\n    0% {\r\n      transform: rotate(0deg);\r\n    }\r\n    100% {\r\n      transform: rotate(360deg);\r\n    }\r\n  }\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
